/* DOOUYOU: shared resources; preserve source order when editing. */
/* Source: brand-neutral.js */
(() => {
  'use strict';
  const label = document.documentElement.dataset.beadMaterial || 'Fuse beads';
  const neutral = value => String(value ?? '').replace(/\bDOOYOU\b/gi, 'DOOUYOU').replace(/\b(?:MARD|Artkal(?:[ -]+M)?|Hama|Perler|COCO|MANMAN|PANPAN|MIXIAOWO|Nabbi|Pyssla|PixelBeads)\b/gi, () => label);
  const excluded = 'script, style, textarea, input, [contenteditable="true"]';
  for (const root of document.querySelectorAll('[data-brand-neutral]')) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest(excluded)) continue;
      const next = neutral(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    for (const element of [root, ...root.querySelectorAll('[alt], [title], [aria-label]')]) {
      if (element.matches(excluded)) continue;
      for (const attribute of ['alt', 'title', 'aria-label']) {
        if (!element.hasAttribute(attribute)) continue;
        const current = element.getAttribute(attribute), next = neutral(current);
        if (next !== current) element.setAttribute(attribute, next);
      }
    }
  }
})();
;

/* Source: dooyou.js */
(()=>{
const init=()=>{
 const languages=[...document.querySelectorAll('.dy-language')];
 languages.forEach(details=>details.addEventListener('toggle',()=>{if(details.open){languages.forEach(other=>{if(other!==details)other.open=false;});const menu=document.querySelector('.dy-mobile-menu');if(menu)menu.open=false;}}));
 document.addEventListener('click',event=>languages.forEach(details=>{if(details.open&&!details.contains(event.target))details.open=false;}));
 document.addEventListener('keydown',event=>{if(event.key==='Escape')languages.forEach(details=>{if(details.open){event.preventDefault();details.open=false;details.querySelector('summary').focus();}});});
 document.querySelectorAll('.dy-mobile-menu a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
 document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{
  const option=select.selectedOptions[0];if(!option)return;
  const form=select.closest('form'),info=select.closest('.dy-product__info');if(!form||!info)return;
  const button=form.querySelector('[data-add-to-cart]'),price=info.querySelector('[data-product-price]'),quantity=form.querySelector('[name="quantity"]'),compare=info.querySelector('[data-compare-price]');
  if(price)price.textContent=option.dataset.price;
  const restock=info.querySelector('[data-restock-panel]');if(restock){restock.hidden=option.dataset.available==='true';const restockVariant=restock.querySelector('[data-restock-variant]');if(restockVariant)restockVariant.value=option.textContent.trim();}
  if(compare)compare.hidden=true;
  if(button){const available=option.dataset.available==='true';button.disabled=!available;button.textContent=available?`${button.dataset.availableLabel} ↗`:button.dataset.soldOutLabel;}
  if(quantity){quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;}
  const url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url);
 }));
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
;

/* Source: site-navigation.js */
(() => {
  const initialized = new WeakSet();
  const initialize = header => {
    if (initialized.has(header)) return;
    const panel = header.querySelector('[data-site-navigation]');
    const openButton = header.querySelector('[data-site-menu-open]');
    const closeButton = header.querySelector('[data-site-menu-close]');
    if (!panel || !openButton || !closeButton || typeof panel.showModal !== 'function' || typeof panel.show !== 'function') return;
    initialized.add(header);
    const media = window.matchMedia('(min-width: 1100px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const languageHome = header.querySelector('[data-site-language-home]');
    const languageMobile = header.querySelector('[data-site-language-mobile]');
    const language = languageHome?.querySelector('.dy-language');
    const accountHome = header.querySelector('[data-site-account-home]');
    const accountMobile = header.querySelector('[data-site-account-mobile]');
    const account = accountHome?.querySelector('[data-account-menu-root]');
    const submenus = [...header.querySelectorAll('[data-site-submenu]')];
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let mobileOpen = false;
    let phase = 'closed';
    let frame = 0;
    let closeTimer = 0;
    let restoreAfterClose = true;
    const closeSubmenus = except => submenus.forEach(details => { if (details !== except) details.open = false; });
    const cancelScheduled = () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(closeTimer);
      frame = 0;
      closeTimer = 0;
    };
    const releaseMobile = () => {
      cancelScheduled();
      phase = 'closed';
      mobileOpen = false;
      document.documentElement.classList.remove('dy-site-drawer-open');
      openButton.setAttribute('aria-expanded', 'false');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('data-navigation-state');
    };
    const finishClose = () => {
      const restoreFocus = restoreAfterClose;
      if (panel.open && mobileOpen) panel.close();
      releaseMobile();
      closeSubmenus();
      if (restoreFocus && !media.matches && openButton.isConnected) openButton.focus({ preventScroll: true });
    };
    const closeMobile = (restoreFocus = true, immediately = false) => {
      if (!mobileOpen) return;
      restoreAfterClose = restoreFocus;
      if (phase === 'closing' && !immediately) return;
      cancelScheduled();
      if (immediately || reducedMotion.matches || phase === 'opening') { finishClose(); return; }
      phase = 'closing';
      panel.setAttribute('data-navigation-state', 'closing');
      openButton.setAttribute('aria-expanded', 'false');
      // Keep the native focus trap until the exit finishes, with a fallback if a transition is interrupted.
      closeTimer = window.setTimeout(finishClose, 260);
    };
    const openMobile = () => {
      if (media.matches || (mobileOpen && phase !== 'closing')) return;
      const reversingClose = mobileOpen && panel.open;
      cancelScheduled();
      if (!reversingClose) {
        if (panel.open) panel.close();
        panel.setAttribute('data-navigation-state', 'opening');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.showModal();
      }
      mobileOpen = true;
      phase = 'opening';
      document.documentElement.classList.add('dy-site-drawer-open');
      openButton.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
      const reveal = () => {
        frame = 0;
        if (!mobileOpen || phase !== 'opening') return;
        phase = 'open';
        panel.setAttribute('data-navigation-state', 'open');
      };
      if (reducedMotion.matches || reversingClose) reveal();
      else frame = window.requestAnimationFrame(() => { frame = window.requestAnimationFrame(reveal); });
    };
    const synchronize = () => {
      closeMobile(false, true);
      closeSubmenus();
      if (language && languageHome && languageMobile) { language.open = false; (media.matches ? languageHome : languageMobile).append(language); }
      if (account && accountHome && accountMobile) { const disclosure = account.querySelector('[data-account-menu]'); if (disclosure) disclosure.open = false; (media.matches ? accountHome : accountMobile).append(account); }
      if (media.matches) { panel.setAttribute('role', 'presentation'); if (!panel.open) panel.show(); }
      else { panel.setAttribute('role', 'dialog'); if (panel.open) panel.close(); }
      releaseMobile();
    };
    openButton.addEventListener('click', openMobile, options);
    closeButton.addEventListener('click', () => closeMobile(), options);
    panel.addEventListener('cancel', event => { if (mobileOpen) { event.preventDefault(); closeMobile(); } }, options);
    panel.addEventListener('close', () => { if (!panel.open) releaseMobile(); }, options);
    panel.addEventListener('transitionend', event => {
      if (phase === 'closing' && event.target === panel && event.propertyName === 'opacity') finishClose();
    }, options);
    panel.addEventListener('click', event => {
      if (!mobileOpen || event.target !== panel) return;
      const bounds = panel.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeMobile();
    }, options);
    submenus.forEach(details => {
      details.addEventListener('toggle', () => { if (details.open) closeSubmenus(details); }, options);
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) { event.preventDefault(); event.stopPropagation(); details.open = false; details.querySelector('summary').focus({ preventScroll: true }); }
      }, options);
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target) || !event.target.closest('[data-site-submenu]')) closeSubmenus();
    }, options);
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || mobileOpen) return;
      const active = submenus.find(details => details.open);
      if (active) { event.preventDefault(); active.open = false; active.querySelector('summary').focus({ preventScroll: true }); }
    }, options);
    header.addEventListener('click', event => {
      if (event.target.closest('.dy-site-nav a, .dy-site-navigation__extras > a')) { closeSubmenus(); if (mobileOpen) closeMobile(false); }
    }, options);
    media.addEventListener('change', synchronize, options);
    reducedMotion.addEventListener('change', () => {
      if (!reducedMotion.matches) return;
      if (phase === 'closing') finishClose();
      else if (phase === 'opening') { cancelScheduled(); phase = 'open'; panel.setAttribute('data-navigation-state', 'open'); }
    }, options);
    window.addEventListener('pagehide', () => closeMobile(false, true), options);
    window.addEventListener('pageshow', event => { if (event.persisted) synchronize(); }, options);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(header)) { closeMobile(false, true); controller.abort(); initialized.delete(header); document.documentElement.classList.remove('dy-navigation-enhanced'); }
    }, options);
    synchronize();
    document.documentElement.classList.add('dy-navigation-enhanced');
  };
  const start = () => document.querySelectorAll('[data-site-header]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();


/* Source: account-menu.js */
(() => {
  const initialized = new WeakSet();
  const initialize = root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const details = root.querySelector('[data-account-menu]');
    const trigger = details.querySelector('summary');
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let checking = false;
    const close = restoreFocus => {
      if (!details.open) return;
      details.open = false;
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };
    const refreshState = async () => {
      if (checking || !root.isConnected || !root.dataset.accountSection) return;
      checking = true;
      const timeout = new AbortController();
      const timer = window.setTimeout(() => timeout.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', root.dataset.accountSection);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: timeout.signal });
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const current = document.querySelector('[data-account-menu-root]');
        if (current && current.dataset.accountSession !== root.dataset.accountSession) window.location.reload();
      } catch {} finally {
        window.clearTimeout(timer);
        checking = false;
      }
    };
    details.addEventListener('toggle', () => { if (details.open) refreshState(); }, options);
    document.addEventListener('click', event => { if (!root.contains(event.target)) close(false); }, options);
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) { event.preventDefault(); close(true); }
    }, options);
    root.addEventListener('focusout', event => { if (event.relatedTarget && !root.contains(event.relatedTarget)) close(false); }, options);
    root.closest('[data-site-header]')?.querySelector('[data-site-menu-open]')?.addEventListener('click', () => close(false), options);
    document.querySelectorAll('shopify-account').forEach(account => account.addEventListener('close', () => { close(false); refreshState(); }, options));
    window.addEventListener('pageshow', event => { if (event.persisted) refreshState(); }, options);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) controller.abort(); }, options);
  };
  const start = () => document.querySelectorAll('[data-account-menu-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
;
